import { Grid, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import CancelButton from "../../components/cancelButton/CancelButton";
import type { AgentFormState } from "./AgentEdit";
import AgentEdit from "./AgentEdit";
import { useCreateAgent } from "./useCreateAgent";

const defaultAgent: () => AgentFormState = () => ({
  name: "",
  phone: "",
  b2bEmail: "",
  przezmorzeEmail: "",
  loginEmail: "",
  privileges: {
    onlyOwnCustomersOrders: false,
    onlyPublicAttachments: false,
    onlyOwnCustomersEdit: false,
    cannotChangeOptionPrices: false,
    cannotExportOrders: false,
    canViewProvidersAndProducts: false,
    canChangeCustomerAccountManager: false,
    canEditProvidersProductsAndDictionaries: false,
    canEditPriceLists: false,
    canEditPackages: false,
    canDeleteCustomerNotes: false,
    cannotViewCustomers: false,
    canViewStatistics: false,
  },
  isAdmin: false,
  department: "",
});

const NewAgentPage = () => {
  const navigate = useNavigate();
  const { createAgent } = useCreateAgent();
  const { control, handleSubmit, watch } = useForm<AgentFormState>({
    defaultValues: defaultAgent(),
    mode: "onBlur",
  });

  const submitAgent = async (state: AgentFormState) => {
    const { id } = await createAgent({
      name: state.name,
      contact: {
        przezmorzeEmail: state.przezmorzeEmail ? state.przezmorzeEmail : undefined,
        b2bEmail: state.b2bEmail ? state.b2bEmail : undefined,
        phone: state.phone ? state.phone : undefined,
      },
      loginEmail: state.loginEmail,
      privileges: state.privileges,
      isAdmin: state.isAdmin,
      department: state.department ? state.department : undefined,
    });
    navigate(`/admin/agents/${id}`);
  };

  return (
    <Grid container spacing={2} sx={{ marginTop: 1, marginBottom: 1, paddingLeft: 1, paddingRight: 1 }}>
      <AgentEdit control={control} isAdmin={watch("isAdmin")} />
      <Grid size={12} container sx={{ justifyContent: "flex-end" }}>
        <Stack direction="row" spacing={2}>
          <CancelButton onClick={() => navigate("/admin/agents")} />
          <AsyncLoadingButton variant="outlined" onClick={handleSubmit(submitAgent)}>
            Zapisz
          </AsyncLoadingButton>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default NewAgentPage;
